import { ApiError } from '@/types/api';

export enum ApiErrorCode {
  UNAUTHORIZED = 'UNAUTHORIZED', // 401 - Não autorizado
  FORBIDDEN = 'FORBIDDEN', // 403 - Proibido
  BAD_REQUEST = 'BAD_REQUEST', // 400 - Requisição inválida
  NOT_FOUND = 'NOT_FOUND', // 404 - Não encontrado
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED', // 405 - Método não permitido
  CONFLICT = 'CONFLICT', // 409 - Conflito
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE', // 413 - Payload muito grande
  UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE', // 415 - Tipo de mídia não suportado
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY', // 422 - Entidade não processável
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS', // 429 - Muitas requisições
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR', // 500 - Erro interno do servidor
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED', // 501 - Não implementado
  BAD_GATEWAY = 'BAD_GATEWAY', // 502 - Gateway inválido
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE', // 503 - Serviço indisponível
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT', // 504 - Tempo limite do gateway
  API_ERROR = 'API_ERROR', // Erro genérico da API
  UNKNOWN_ERROR = 'UNKNOWN_ERROR', // Erro desconhecido
  MESSAGE_DECODE = 'MESSAGE_DECODE' // Erro de decodificação do JSON
}

export class ErrorService {
  static async handleApiError(response: any): Promise<ApiError> {
    console.log('Erro original:', response);
    
    if (response instanceof Response) {
      return this.handleFetchResponse(response);
    }
    
    return this.handleGenericError(response);
  }

  private static async handleFetchResponse(response: Response): Promise<ApiError> {
    try {
      const data = await response.json();
      
      const error = this.createApiError(
        data,
        response.status,
        response.ok ? undefined : this.getErrorCodeFromStatus(response.status)
      );
      return error;
    } catch {
      return this.createApiError({
        message: response.statusText,
        code: ApiErrorCode.MESSAGE_DECODE
      }, response.status);
    }
  }

  private static handleGenericError(response: any): ApiError {
    const status = response.response?.status || response.statusCode || 500;

    return this.createApiError({
      message: response.message || response.error || 'Erro desconhecido',
      code: response.code || this.getErrorCodeFromStatus(status)
    }, status);
  }

  public static getErrorCodeFromStatus(status: number): ApiErrorCode {
    const errorMap: Record<number, ApiErrorCode> = {
      400: ApiErrorCode.BAD_REQUEST,
      401: ApiErrorCode.UNAUTHORIZED,
      403: ApiErrorCode.FORBIDDEN,
      404: ApiErrorCode.NOT_FOUND,
      405: ApiErrorCode.METHOD_NOT_ALLOWED,
      409: ApiErrorCode.CONFLICT,
      413: ApiErrorCode.PAYLOAD_TOO_LARGE,
      415: ApiErrorCode.UNSUPPORTED_MEDIA_TYPE,
      422: ApiErrorCode.UNPROCESSABLE_ENTITY,
      429: ApiErrorCode.TOO_MANY_REQUESTS,
      500: ApiErrorCode.INTERNAL_SERVER_ERROR,
      501: ApiErrorCode.NOT_IMPLEMENTED,
      502: ApiErrorCode.BAD_GATEWAY,
      503: ApiErrorCode.SERVICE_UNAVAILABLE,
      504: ApiErrorCode.GATEWAY_TIMEOUT
    };
    return errorMap[status] || ApiErrorCode.UNKNOWN_ERROR;
  }

  private static createApiError(data: Partial<ApiError>, status: number, defaultCode?: ApiErrorCode): ApiError {
    return {
      code: data.code || defaultCode || ApiErrorCode.UNKNOWN_ERROR,
      message: data.message || data.error || 'Erro desconhecido',
      statusCode: status,
      timestamp: new Date().toISOString(),
      validationErrors: data.validationErrors || {},
      details: data.details || {},
      metadata: data.metadata || {}
    };
  }

  static getFieldError(error: ApiError | null, field: string): string | undefined {
    return error?.validationErrors?.[field]?.message;
  }

  static getFormattedMessage(error: ApiError): string {
    const messages: Record<number, string> = {
      400: 'Usuário ou senha inválidos.',
      401: 'Sessão expirada. Por favor, faça login novamente.',
      403: 'Você não tem permissão para realizar esta ação.',
      404: 'O recurso solicitado não foi encontrado.',
      405: 'Método não permitido.',
      409: 'Conflito de dados. Ação não pode ser concluída.',
      413: 'O arquivo enviado é muito grande.',
      415: 'Tipo de mídia não suportado.',
      422: 'Existem campos com erro no formulário. Por favor, verifique.',
      429: 'Muitas requisições. Tente novamente mais tarde.',
      500: 'Erro interno do servidor. Tente novamente mais tarde.',
      501: 'Funcionalidade não implementada.',
      502: 'Erro de comunicação com o servidor.',
      503: 'Serviço temporariamente indisponível.',
      504: 'Tempo limite da solicitação atingido. Tente novamente.'
    };
    console.log('error',error)
    return error.message || error.error || messages[error.statusCode]  || 'Erro desconhecido.';
  }
}
